import { styled } from "@mui/material/styles";

export const FormDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  width: "100%",
});